import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary-500 text-background-50 py-10 md:py-14 px-4 md:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          <div>
            <h3 className="text-base md:text-lg font-heading font-bold mb-3">YOYBUY Spreadsheet</h3>
            <p className="text-sm text-background-50/75 leading-relaxed max-w-xs">
              Удобная система заказов товаров из Китая через таблицу. Быстрая доставка, низкие цены и полный контроль каждого заказа.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold mb-3">Быстрые ссылки</h4>
            <nav className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-background-50/75 hover:text-background-50 transition-colors cursor-pointer">
                Главная
              </Link>
              <Link to="/blog/yoybuy-spreadsheet-instruktsiya" className="text-sm text-background-50/75 hover:text-background-50 transition-colors cursor-pointer">
                Полное руководство
              </Link>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-background-50/75 hover:text-background-50 transition-colors cursor-pointer">
                Kaspreadsheet.com
              </a>
            </nav>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold mb-3">Популярные категории</h4>
            <div className="flex flex-wrap gap-2">
              {['Обувь', 'Худи', 'Футболки', 'Куртки', 'Сумки', 'Аксессуары'].map((cat) => (
                <span key={cat} className="px-2.5 py-1 rounded-full bg-background-50/15 text-background-50 text-xs">
                  {cat}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/60">
            &copy; {new Date().getFullYear()} yoybuy.guru — Все права защищены.
          </p>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-background-50 text-secondary-700 text-xs font-semibold hover:bg-background-100 transition-colors cursor-pointer"
          >
            <i className="ri-external-link-line w-3 h-3 flex items-center justify-center" />
            Перейти на kaspreadsheet.com
          </a>
        </div>
      </div>
    </footer>
  );
}